import Field from "../../../Components/Field";
import RadioInput from "../RadioInput";

const Proxy = ({ configs, onChange }) => {
  return (
    <>
      <div className="phishbox-settings__line">
        <Field
          label="HTTP Proxy*"
          tooltipText="Address for the HTTP proxy (e.g., proxy.example.com:8080)."
          width="318px"
          name="http_proxy"
          value={configs.http_proxy}
          onChange={onChange}
          placeholder="proxy.example.com:8080"
        />
      </div>
      <div className="phishbox-settings__line">
        <Field
          label="HTTPS Proxy*"
          tooltipText="Address for the HTTPS proxy (e.g., proxy.example.com:8080)."
          width="318px"
          name="https_proxy"
          value={configs.https_proxy}
          onChange={onChange}
          placeholder="proxy.example.com:8080"
        />
      </div>
      <div className="phishbox-settings__line">
        <RadioInput
          label="User Validation"
          tooltipText="Flag to enable or disable user validation checks."
          name="uservalid"
          value={configs.uservalid}
          onChange={onChange}
        />
      </div>
      <div className="phishbox-settings__line">
        <div className="p-r-20">
          <Field
            label="Proxy Username"
            tooltipText="Username for proxy authentication (if required)."
            width="188px"
            name="username"
            value={configs.username}
            onChange={onChange}
            placeholder="proxy_user"
            disabled={configs.uservalid === 1}
          />
        </div>
        <Field
          label="Proxy Password*"
          tooltipText="Password for proxy authentication (if required)."
          width="188px"
          name="password"
          type="password"
          value={configs.password}
          onChange={onChange}
          placeholder="********"
          disabled={configs.uservalid === 1}
        />
      </div>
      <div className="phishbox-settings__line">
        <RadioInput
          label="Use SSL Proxy"
          name="ssl_proxy"
          tooltipText="Enable SSL for proxy connection."
          value={configs.ssl_proxy}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default Proxy;
